import ACTIONS from '../actionTypes/company';

const initialState = {
  companyList: [],
  selectedCompany: {},
  selectedApiDocsCompany: {},
  members: [],
};

export default function company(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_USER_COMPANY_LIST: {
      return {
        ...state,
        companyList: [...action.payload],
      };
    }
    case ACTIONS.SET_USER_SELECTED_COMPANY:
      return {
        ...state,
        selectedCompany: {
          ...action.payload,
        },
        selectedApiDocsCompany: {
          ...(state.selectedApiDocsCompany?.ID ? state.selectedApiDocsCompany : action.payload)
        },
        members: [],
        pendingMembers: []
      };
    case ACTIONS.CLEAR_COMPANY_STORE: {
      return {
        ...initialState,
      };
    }
    case ACTIONS.SET_COMPANY_USERS: {
      return {
        ...state,
        members: [...action.payload.members],
        pendingMembers: [...action.payload.pendingMembers] 
      };
    }
    case ACTIONS.SET_USER_SELECTED_API_DOCS_COMPANY:
      return {
        ...state,
        selectedApiDocsCompany: {
          ...action.payload,
        },
      };
    default:
      return state;
  }
}
